import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './constants';
import './Launch.scss'

import HiddenPanel from "../../partials/HiddenPanel"
import Button from "../../partials/Button";
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Modal, { ModalProvider } from "../../partials/Modal/v2/modal";
import StyledContainer from "../../partials/StyledContainer";
import ButtonsHolder from "../../partials/Button/ButtonsHolder";

import Parameters from "./Parameters";
import Decisions from "./Desicions";
import Results from "./Results";
import Conclusions from "./Conclusions";
import Scroll from '../../partials/Scroll/Scroll';
import Instructions from '../../partials/Instructions/Instructions'
import { LaunchView } from './constants/index';
import CurrentParameters from './CurrentParameters/CurrentParameters';


const CurrentParametersBtn = ({ currentParameters }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <div className="currentparameters_button">
                <Button
                    text={`Complete Mission Parameters`}
                    className={"primary"}
                    onClick={() => { setIsOpen(true) }}
                />
            </div>
            {isOpen && (
                <Modal>
                    <StyledContainer style={{ height: `60%`, width: `50%` }}>
                        <CurrentParameters currentParameters={currentParameters} />
                        <ButtonsHolder orientation="right">
                            <Button text={"Close"} onClick={() => { setIsOpen(false) }} />
                        </ButtonsHolder>
                    </StyledContainer>
                </Modal>
            )}
        </>
    )
}

const Launch = (props) => {
    const { data } = props;

    validatedData(data);
    const { options, rockets, locations, subjects, parameters, decisions, isfit_rocket } = data;


    const [currentParameters, setCurrentParameters] = useState({
        satellite: data.satellite || {},
        rocket: {
            name: 'TBD',
            img: "media/img/launch/hawk.svg",
            custom: [],
        },
        decisions: [],
        location: {}
    });

    const [launchState, setLaunchState] = useState({
        currentView: LaunchView.Parameters,
    })

    const handleRocketChoice = (rocketChosen) => {
        if (rocketChosen && rocketChosen.model === isfit_rocket) {
            setCurrentParameters({
                ...currentParameters,
                rocket: {
                    name: rocketChosen.model,
                    img: rocketChosen.image,
                    custom: [
                        { 'description': `${rocketChosen.diameter}m  diameter` },
                        { 'description': `${rocketChosen.height.max}m  height` },
                        { 'description': `${rocketChosen.mass} Kg Mass` },
                        { 'description': `${rocketChosen.orbit} Km Orbit` },
                    ],
                }
            })
            setLaunchState({
                currentView: LaunchView.Decisions
            })
        }
    }

    const handleLocationChosen = (location) => {
        setCurrentParameters({
            ...currentParameters,
            location: location || {},
        })
        setLaunchState({
            currentView: LaunchView.Conclusions
        })
    }

    const handleDecisionsTaken = (summary) => {

        const decisionsTaken = [];

        summary.forEach(d => {
            const correct = d.options.find(e => e.is_correct === true)
            if (correct) {
                decisionsTaken.push({
                    description: `${d.caption}: ${correct.caption}`
                })
            }
        });

        setCurrentParameters({
            ...currentParameters,
            decisions: decisionsTaken,
        });

        setLaunchState({
            currentView: LaunchView.Results
        });

    }

    const getCurrentView = () => {
        switch (launchState.currentView) {
            case LaunchView.Parameters:
                return <Parameters
                    parameters={parameters}
                    options={options}
                    rockets={rockets}
                    subjects={subjects}
                    isfit_rocket={isfit_rocket}
                    onRightChoice={handleRocketChoice}
                />
            case LaunchView.Decisions:
                return <Decisions
                    decisions={decisions}
                    locations={locations}
                    rocketrep={subjects[0]}
                    teammember={subjects[1]}
                    onDecisionsTaken={handleDecisionsTaken}
                    currentParameters={currentParameters}
                />
            case LaunchView.Results:
                return <Results
                    subjects={subjects}
                    locations={locations}
                    onChoosedLocation={handleLocationChosen}
                />
            case LaunchView.Conclusions:
                return <Conclusions
                    subjects={subjects}
                    rocket={currentParameters.rocket} l
                    decisions={currentParameters.decisions}
                    location={currentParameters.location}
                    captions={data?.options?.captions}
                    onDone={() => {
                        if (props.onComplete) {
                            props.onComplete()
                        }
                    }}
                />
            default:
                throw new Error('State dont have Current View')
        }
    }

    const currentView = getCurrentView();

    const intro = (props.data.intro !== undefined) ?
        <Instructions body={props.data.intro} className="header" />
        : null;

    const missionRequirements = (data.missionRequirements !== undefined)
        ? (
            <HiddenPanel button="Mission Requirements">
                <div dangerouslySetInnerHTML={{ __html: data.missionRequirements }} ></div>
            </HiddenPanel>
        )
        : null;

    return (
        <InteractionContainer withFrame={false} breadcrumbs={props.breadcrumbs}>
            <div style={{ marginTop: "-1.5%" }}>
                {intro}
            </div>


            <div className="back-btn-container">
                <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
            </div>
            <div className="launch_module">
                <CurrentParametersBtn currentParameters={currentParameters} />
                {currentView}
            </div>

            {missionRequirements}

        </InteractionContainer>
    )
}
function validatedData(data) {
    if (data === null || data === undefined || typeof data !== 'object') throw new Error('Invalid or missing data');

    if (!data.options) throw new Error('Invalid or missing prop data: options');
    if (!data.rockets) throw new Error('Invalid or missing prop data: rockets');
    if (!data.locations) throw new Error('Invalid or missing prop data: locations');
    if (!data.subjects) throw new Error('Invalid or missing prop data: subjects');
    if (!data.decisions) throw new Error('Invalid or missing prop data: decisions');
    if (!data.isfit_rocket) throw new Error('Invalid or missing prop data: isfit_rocket');
    if (!data.satellite) throw new Error('Invalid or missing prop data: satellite');
}

Launch.propTypes = {
    data: PropTypes.object.isRequired,
    globals: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired
}

const addProviders = (Component) => (props) => {
    return <ModalProvider><Component {...props} /></ModalProvider>
}

export default addProviders(Launch)

